<script setup>
import {ref, reactive, onMounted} from "vue";
import {CountTo} from "vue3-count-to";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import {getClubStatistics, listClubUser} from "@/api/club/club.js";
import YTTag from "@/components/YTTag/index.vue"
import router from "@/router/index.js";
import YTInputPhoneDialog from "@/components/YTInputPhoneDialog/index.vue";
import YTAuditUserDialog from "@/components/YTAuditUserDialog/index.vue";
import YTGender from "@/components/YTGender/index.vue";
import {formatTags} from "@/hooks/tag.js"

/*初次加载*/
onMounted(async () => {
  await handleSearch()
  await handleGetData()
})

/*统计数据相关功能*/
// 统计数据
const statisticsData = reactive({
  memberTotal: 0,
  thisYearTotal: 0,
  thisWeekTotal: 0,
  pendingApplicationsTotal: 0
})
// 处理获取统计数据
const handleGetData = async () => {
  try {
    loading.value = true
    const res = await getClubStatistics()
    statisticsData.memberTotal = parseInt(res.memberTotal)
    statisticsData.thisYearTotal = parseInt(res.thisYearTotal)
    statisticsData.thisWeekTotal = parseInt(res.thisWeekTotal)
    statisticsData.pendingApplicationsTotal = parseInt(res.pendingApplicationsTotal)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*过滤器相关功能*/
// 过滤器表单
const formData = reactive({
  name: null,
  phone: null
})

// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  console.log("run in handleSearch")
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await listClubUser(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.name = null
  formData.phone = null
  handleSearch('btnSearch')
}
// 处理跳转审核列表
const handle2Audit = () => {
  router.push("/store/listUserAudit")
}

/*表格相关功能*/
// 表格加载状态
const loading = ref(false)
// 表格数据
const tableData = ref([])
// 表格数据总条数
const total = ref(0)
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 处理翻页
const handleChangePage = () => {
  handleSearch()
}
// 联系电话展示状态
const isShowPhone = ref(false)
// 处理联系电话展示
const handleShowPhone = () => {
  isShowPhone.value = !isShowPhone.value
}
// 处理录入联系手机
const handleChekInPhone = (info) => {
  phoneCacheData.value = info
  YTInputPhoneDialogRef.value.handleOpen()
}
// 处理编辑会员信息
const handleEdit = (info) => {
  editCacheData.value = info
  YTAuditUserDialogRef.value.handleOpen()
  YTAuditUserDialogRef.value.handleChangeRules('pass')
}

/*录入手机号弹窗相关功能*/
// 录入手机号弹窗锚点
const YTInputPhoneDialogRef = ref()
// 弹窗缓存数据
const phoneCacheData = ref({})

// 处理录入手机号弹窗关闭
const handleClosePhone = () => {
  phoneCacheData.value = null
}

/*编辑会员信息弹窗相关功能，暂无编辑页面，使用弹窗代替*/
// 编辑会员弹窗锚点
const YTAuditUserDialogRef = ref()
// 编辑会员弹窗缓存
const editCacheData = ref()
// 处理编辑会员弹窗修改成功
const handleUpdateSuccess = () => {
  YTAuditUserDialogRef.value.handleClose()
  handleSearch()
}
</script>

<template>
  <div class="flex" style="margin-bottom: 22px">
    <v-row justify="center">
      <v-col cols="3">
        <div class="info_item">
          <countTo
              :title="statisticsData.memberTotal"
              class="info_item_num txt_overflow"
              :startVal="0"
              :endVal="statisticsData.memberTotal"
              :duration="3000"
          ></countTo>
          <div>当前会员总人数</div>
        </div>
      </v-col>
      <v-col cols="3">
        <div class="info_item">
          <countTo
              :title="statisticsData.thisYearTotal"
              class="info_item_num txt_overflow"
              :startVal="0"
              :endVal="statisticsData.thisYearTotal"
              :duration="3000"
          ></countTo>
          <div>今年新增会员人数</div>
        </div>
      </v-col>
      <v-col cols="3">
        <div class="info_item">
          <countTo
              :title="statisticsData.thisWeekTotal"
              class="info_item_num txt_overflow"
              :startVal="0"
              :endVal="statisticsData.thisWeekTotal"
              :duration="3000"
          ></countTo>
          <div>本周新增会员人数</div>
        </div>
      </v-col>
      <v-col cols="3">
        <div class="info_item flex_bt">
          <div>
            <countTo
                :title="statisticsData.pendingApplicationsTotal"
                class="info_item_num txt_overflow"
                :startVal="0"
                :endVal="statisticsData.pendingApplicationsTotal"
                :duration="3000"
            ></countTo>
            <div>待审核申请</div>
          </div>
          <div class="flex_center">
            <v-btn color="#CE6043" @click="handle2Audit">去处理</v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
  <div class="new_container_box">
    <div class="table_filter_box flex_bt mg_b_2">
      <div class="table_filter_title">
        会员
      </div>
      <div class="flex">
        <el-input v-model="formData.name" :class="formData.name === null || formData.name === '' ? 'input-null mg_r_2' : 'input-filled mg_r_2'" style="width:170px;" placeholder="会员昵称"></el-input>
        <el-input v-model="formData.phone" :class="formData.phone === null || formData.phone === '' ? 'input-null' : 'input-filled'" style="width:170px;" placeholder="会员电话"></el-input>
        <!-- TODO 暂无标签功能，先隐藏 -->
<!--        <el-input class="mg_r_2" style="width:170px;" placeholder="标签昵称"></el-input>-->
        <v-btn style="margin-right: 15px;margin-left: 40px;" color="#4CAF50" @click="handleSearch('btnSearch')">搜索</v-btn>
        <v-btn color="#d7d7df" @click="handleReset">重置</v-btn>
      </div>
    </div>
    <div style="margin-bottom: 25px">
      <el-table
          :data="tableData"
          :border="false"
          style="width: 100%;"
          :header-row-style="{color: '#272539'}"
          :row-style="{color: '#656565'}"
          v-loading="loading"
          stripe
      >
        <el-table-column prop="avatar" label="会员头像" align="center">
          <template #default="scope">
            <img style="width: 34px;height: 34px;border-radius: 34px;" :src="scope.row.avatar ? scope.row.avatar : 'https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/default_avatar.svg'">
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="会员昵称" width="150">
          <template #default="scope">
            <span></span>
            <el-link
                type="default"
                :underline="false"
                style="text-decoration: underline; padding-left: 13px"
                @click="handleEdit(scope.row)"
            >
              {{scope.row.nickname ? scope.row.nickname : "—"}}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="gender" label="性别">
          <template #default="scope">
            <YTGender :gender="scope.row.gender"></YTGender>
          </template>
        </el-table-column>
        <el-table-column prop="crTime" label="加入时间" sortable  min-width="150">
          <template #default="scope">
            <span>{{scope.row.crTime ? scope.row.crTime : "—"}}</span>
          </template>
        </el-table-column>

        <el-table-column label="会员标签" width="250" show-overflow-tooltip :tooltip-formatter="formatTags">
          <template #default="scope">
            <div >
              <div v-if="scope.row.tagList.length > 0">
                <YTTag
                    v-for="(item, index) in scope.row.tagList"
                    class="mg_r_1"
                    :key="`tagList${index}`"
                    :label="item.tagName"
                    :type="'primary'"
                ></YTTag>
              </div>
              <div v-else>—</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="carBrand" label="车辆品牌">
          <template #default="scope">
            <span>{{scope.row.carBrand ? scope.row.carBrand : "—"}}</span>
          </template>
        </el-table-column>>
        <el-table-column prop="ftp" label="FTP">
          <template #default="scope">
            <span>{{scope.row.ftp ? scope.row.ftp + "W" : "—"}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="thisYearActivityCount" label="本年活动">
          <template #default="scope">
            <span>{{scope.row.thisYearActivityCount ? scope.row.thisYearActivityCount : "—"}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="联系电话" width="120">
          <template #header>
            <div class="flex_center flex_left cursor-pointer" @click="handleShowPhone">
              <div style="margin-right: 15px">联系电话</div>
              <img src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/default_eyes_open.svg" v-if="isShowPhone">
              <img src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/default_eyes_close.svg" v-else>
            </div>
          </template>
          <template #default="scope">
            <div v-if="scope.row.phone">
              <div v-if="isShowPhone">{{scope.row.phone}}</div>
              <div v-else>{{scope.row.phone.slice(0, 3)}}*****{{scope.row.phone.slice(-3)}}</div>
            </div>
            <div v-else>
              <span>{{scope.row.phone ? scope.row.phone : "—"}}</span>
            </div>
            <!-- TODO 暂时隐藏 -->
<!--            <YTTag class="cursor-pointer" :label="'录入'" @click="handleChekInPhone(scope.row)"></YTTag>-->
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="备注">
          <template #default="scope">
            <span>{{scope.row.remarks ? scope.row.remarks : "—"}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pd_b_4" style="padding-right: 20px;">
      <YTTablePagination ref="YTTablePaginationRef" :pageSize="$globalPageSize" :total="total" @page-change="handleChangePage"></YTTablePagination>
    </div>
  </div>
  <YTAuditUserDialog ref="YTAuditUserDialogRef" :type="'edit'" :audit-cache-date="editCacheData" @success="handleUpdateSuccess"></YTAuditUserDialog>
  <!-- TODO 暂时隐藏 -->
<!--  <YTInputPhoneDialog ref="YTInputPhoneDialogRef" :phone-cache-data="phoneCacheData" @close="handleClosePhone"></YTInputPhoneDialog>-->
</template>

<style scoped>

</style>
